import React, { Component } from "react";
import logo from "../assets/img/logo.png";
import config from "../../config";
import { Link } from "gatsby";
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      visibilityClass: "",
    };
  }
  toggleMenu = (value) => {
    this.setState({ openMenu: value });
  };
  handleScroll = () => {
    const { visibilityClass } = this.state;
    if (window.pageYOffset > 300) {
      if (visibilityClass !== "navbar-shrink") {
        this.setState({ visibilityClass: "navbar-shrink" });
      }
    } else {
      if (visibilityClass === "navbar-shrink") {
        this.setState({ visibilityClass: "" });
      }
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const { openMenu } = this.state;
    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top`}
        id="mainNav"
      >
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="site-logo" />
          </Link>
          <button
            onClick={(_) => this.toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? "" : "collapsed"
            }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            menu &nbsp;
            <i className="fas fa-bars" />
          </button>
          <div
            className={`collapse navbar-collapse ${openMenu ? "show" : ""}`}
            id="navbarResponsive"
          >
            <ul className="navbar-nav ml-auto mr-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link" activeClassName="active">
                  home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/agent/"
                  className="nav-link"
                  activeClassName="active"
                >
                  agent
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/customer/"
                  className="nav-link"
                  activeClassName="active"
                >
                  customer
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/about/"
                  className="nav-link"
                  activeClassName="active"
                >
                  about
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/apply/"
                  className="nav-link"
                  activeClassName="active"
                >
                  apply
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/faq/" className="nav-link" activeClassName="active">
                  faq
                </Link>
              </li>
            </ul>
            <ul className="navbar-nav ml-auto">
              <div className="social d-flex justify-content-center">
                {config.socialLinks.map((social) => {
                  const { icon, url } = social;
                  return (
                    <a key={icon} href={url} className={`mx-2`}>
                      <i className={`fab ${icon}`} />
                    </a>
                  );
                })}
              </div>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
